function LandingPage() {
  return (
    <div className="LandingPage" style={{width: '100%', height: '100%', background: 'black'}}>
      <img src={require('./savupiippu.png')} alt="savupiippu-ukko" style={{width: '100%',height: '100%', resizeMode: 'contain'}}></img>
    </div>
  );
}

export default LandingPage;
